import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import CompanyOverview from "./CompanyOverview";
import WhoWeAre from "./WhoWeAre";
import CompanyHistory from "./CompanyHistory";
import MissionVisionValues from "./MissionVisionValues";
import OurExpertise from "./OurExpertise";
import LeadershipTeam from "./LeadershipTeam";
import ISOcertifications from "./ISOcertifications";
import ManufacturingFacility from "./ManufacturingFacility";
import OurStrengths from "./OurStrengths";
import CorporateResponsibility from "./CorporateResponsibility";
import AboutHeroSection from "./AboutHeroSection";
import AboutCTA from "./AboutCTA";
import AwardsRecognition from "./AwardsRecognition";
import Seo from "../../components/Seo";

export default function AboutPage() {
  return (
    <Box>
      <Seo
        title="About Burj Al Yarmouk Industries LLC – Engineering, Fabrication & Industrial Solutions in UAE"
        description="Burj Al Yarmouk Industries LLC is a leading engineering and metal fabrication company in the UAE, specializing in storage tanks, generator acoustic enclosures, skid frames, pipeline structures, STP tanks, and custom fabrication. With over a decade of expertise, we deliver precision-engineered solutions trusted across industries."
        url="https://burjalyarmouk.com/about-us"
        image="https://burjalyarmouk.com/og-banner.jpg"
        keywords="
    about burj al yarmouk,
    fabrication company uae,
    engineering company abu dhabi,
    industrial fabrication experts uae,
    generator enclosure manufacturer uae,
    diesel storage tank fabrication,
    skid frame fabrication company,
    custom metal works uae,
    steel fabrication abu dhabi,
    engineering solutions uae
  "
        schema={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Burj Al Yarmouk Industries LLC",
          url: "https://burjalyarmouk.com/about-us",
          logo: "https://burjalyarmouk.com/favicon.ico",
          description:
            "Leading engineering and fabrication company in the UAE specializing in storage tanks, STP tanks, fuel tanks, generator acoustic enclosures, skid structures, and custom steel fabrication services.",
          foundingDate: "2015",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Abu Dhabi",
            addressRegion: "Abu Dhabi",
            addressCountry: "UAE",
          },
          sameAs: [
            "https://www.instagram.com/burjalyarmouk/",
            "https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347/",
          ],
        }}
      />

      <AboutHeroSection />
      <CompanyOverview />
      <WhoWeAre />
      <CompanyHistory />
      <MissionVisionValues />
      <OurExpertise />
      {/* <LeadershipTeam /> */}
      {/* <AwardsRecognition /> */}
      <ISOcertifications />
      {/* <ManufacturingFacility /> */}
      <OurStrengths />
      <CorporateResponsibility />
      <AboutCTA />
    </Box>
  );
}
